import React from 'react';
import { useNavigate } from 'react-router-dom';
import './iOSInstallGuide.css';

const IOSInstallGuide = () => {
  const navigate = useNavigate();

  return (
    <div className="ios-guide-container">
      {/* الرأس */}
      <div className="ios-guide-header">
        <button className="back-btn" onClick={() => navigate(-1)}>
          ← العودة
        </button>
        <h1>تثبيت على iPhone</h1>
      </div>

      {/* المحتوى */}
      <div className="ios-guide-content">
        <div className="guide-intro">
          <div className="logo-circle">
            <img src="/icons/icon-192x192.png" alt="ORASCOM Lab" />
          </div>
          <h2>ORASCOM Lab</h2>
          <p>اتبع الخطوات أدناه لتثبيت التطبيق على جهازك</p>
        </div>

        {/* الخطوات */}
        <div className="steps-container">
          {/* الخطوة 1 */}
          <div className="step">
            <div className="step-number">1</div>
            <div className="step-content">
              <h3>افتح المتصفح Safari</h3>
              <p>تأكد من فتح الموقع في متصفح Safari وليس Chrome أو متصفح آخر</p>
              <div className="step-icon">📱</div>
            </div>
          </div>

          {/* الخطوة 2 */}
          <div className="step">
            <div className="step-number">2</div>
            <div className="step-content">
              <h3>اضغط على أيقونة المشاركة</h3>
              <p>في الأسفل من الشاشة، اضغط على أيقونة المشاركة (مربع بسهم يخرج منه)</p>
              <div className="step-icon">↗️</div>
            </div>
          </div>

          {/* الخطوة 3 */}
          <div className="step">
            <div className="step-number">3</div>
            <div className="step-content">
              <h3>اختر "أضف إلى الشاشة الرئيسية"</h3>
              <p>مرّر القائمة لليسار واختر "أضف إلى الشاشة الرئيسية"</p>
              <div className="step-icon">🏠</div>
            </div>
          </div>

          {/* الخطوة 4 */}
          <div className="step">
            <div className="step-number">4</div>
            <div className="step-content">
              <h3>اضغط "إضافة"</h3>
              <p>ستظهر نافذة تحتوي على اسم التطبيق والأيقونة، اضغط الزر "إضافة" في الأعلى اليمين</p>
              <div className="step-icon">✓</div>
            </div>
          </div>

          {/* الخطوة 5 */}
          <div className="step">
            <div className="step-number">5</div>
            <div className="step-content">
              <h3>تم! 🎉</h3>
              <p>سيظهر التطبيق على الشاشة الرئيسية بأيقونة ORASCOM Lab. يمكنك الآن استخدام التطبيق دون الحاجة لفتح المتصفح</p>
              <div className="step-icon">🎉</div>
            </div>
          </div>
        </div>

        {/* ملاحظات مهمة */}
        <div className="important-notes">
          <h3>⚠️ ملاحظات مهمة:</h3>
          <ul>
            <li>استخدم متصفح Safari فقط (لا يعمل مع Chrome على iPhone)</li>
            <li>تأكد من اتصالك بالإنترنت</li>
            <li>قد تحتاج لتحديث iOS إلى أحدث إصدار</li>
            <li>التطبيق يعمل Offline بعد التثبيت</li>
          </ul>
        </div>

        {/* الأزرار */}
        <div className="guide-actions">
          <button 
            className="btn-back" 
            onClick={() => navigate(-1)}
          >
            ← العودة للموقع
          </button>
          <button 
            className="btn-help" 
            onClick={() => window.open('https://support.apple.com/ar-sa/guide/iphone/iph42ab2f3a7/ios', '_blank')}
          >
            ℹ️ المزيد من المساعدة
          </button>
        </div>
      </div>
    </div>
  );
};

export default IOSInstallGuide;